module.exports = __webpack_public_path__ + "static/media/bank-of-ireland.646bc5ec.svg";